module.exports = __webpack_public_path__ + "static/media/default.2388207a.png";